<template>
  <div>
    <el-table
      stripe
      :data="realData"
      v-if="colConfigs"
      :border="border"
      :span-method="objectSpanMethod"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      :row-key="rowKey"
      :show-header="showheader"
      :select-on-indeterminate="true"
      :header-cell-style="{
        'background-color': '#F7F8FA',
        color: '#858692',
        height: '50px',
      }"
      :empty-text='emptytext'
    >
      <template v-for="(colConfig, index) in colConfigs">
        <el-table-column
          v-if="!colConfig.header && colConfig.render"
          v-bind="colConfig"
          :key="colConfig.column"
          align="center"
          header-align="center"
          :sortable="colConfig.sortable"
          :width="colConfig.width"
          :min-width="colConfig.minWidth"
          :show-overflow-tooltip="colConfig.isShowTip"
          :label="colConfig.label"
          :prop="colConfig.type"
          :reserve-selection="reserveSelection"
        >
          <template slot-scope="scope">
            <extendRender
              :render="colConfig.render"
              :params="scope"
            ></extendRender>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="colConfig.header"
          v-bind="colConfig"
          :key="colConfig.column"
          align="center"
          header-align="center"
          :sortable="colConfig.sortable"
          :width="colConfig.width"
          :min-width="colConfig.minWidth"
          :show-overflow-tooltip="colConfig.isShowTip"
          :label="colConfig.label"
          :prop="colConfig.type"
          :reserve-selection="reserveSelection"
        >
          <template slot="header" slot-scope="scope">
            <extendHeaderRender
              :render="colConfig.header"
              :params="scope"
            ></extendHeaderRender>
          </template>
          <template slot-scope="scope">
            <extendRender
              :render="colConfig.render"
              :params="scope"
            ></extendRender>
          </template>
        </el-table-column>
        <!--  -->
        <el-table-column
          v-else
          v-bind="colConfig"
          :key="colConfig.column"
          :sortable="colConfig.sortable"
          align="center"
          header-align="center"
          :prop="colConfig.type"
          :show-overflow-tooltip="colConfig.isShowTip"
          :reserve-selection="reserveSelection"
        ></el-table-column>
      </template>
    </el-table>
    <br />
    <el-pagination
      v-if="!!pagination"
      style="display: flex; justify-content: center; margin-top: 20px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      background
      layout="prev, pager, next"
      :total="+count"
    ></el-pagination>
    <!-- layout="total, prev, pager, next,sizes" -->
  </div>
</template>

<script>
const extendHeaderRender = {
  props: {
    params: {
      type: Object,
    },
    render: {
      type: Function,
    },
  },
  render(h) {
    const { $index: index, column } = this.params;
    return this.render && this.render(column, index, h);
  },
};
const extendRender = {
  props: {
    params: {
      type: Object,
    },
    render: {
      type: Function,
    },
  },
  render(h) {
    const { $index: index, row, column } = this.params;

    return this.render && this.render(row[column.property], row, index, h);
  },
};
export default {
  name: "commonTable",
  components: {
    extendHeaderRender,
    extendRender,
  },
  props: {
    emptytext: {
      type: String,
      default: "暂无数据",
    },
    disabledRowKeysName: {
      type: String,
      default: "",
    },
    expandCongigs: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    colConfigs: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    border: {
      type: Boolean,
      default: false,
    },
    objectSpanMethod: {
      type: Function,
      default: () => {},
    },
    count: {
      type: Number | String,
      default: 0,
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 30, 40, 50, 100];
      },
    },
    pageSize: {
      type: Number | String,
      default: 10,
    },
    currentPage: {
      type: Number | String,
      default: 1,
    },
    pagination: {
      type: Boolean,
      default: false,
    },

    selectRowKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },

    rowKey: {
      type: Number | String,
      default: "id",
    },

    reserveSelection: {
      type: Boolean,
      default: false,
    },
    showheader: {
      type: Boolean,
      default: true,
    },
    radioAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    realData() {
      return this.data;
    },
  },
  watch: {
    data: {
      handler(newName, oldName) {
        this.$nextTick(() => {
          this.toggleSelection(newName);
        });
      },
      deep: true,
      immediate: true,
    },

    colConfigs: {
      handler(newName, oldName) {},
      deep: true,
      immediate: true,
    },
  },

  methods: {
    sortChange({ column, prop, order }) {},

    handleSelectionChange(val) {
      this.toggleSelection(val);
      this.$emit("select-row", val);
    },
    toggleSelection(rows) {
      rows &&
        rows.forEach((row) => {
          if (row.isSelected == 1) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
          if (this.selectRowKeys.includes(row[this.rowKey])) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
    },
    activeAllClick(radioAll) {
      if (radioAll) {
        this.$refs.multipleTable.toggleAllSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.radioAll = radioAll;
    },
    handleClearSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    handleSizeChange(val) {
      this.$emit("change-page", { pageSize: val, currentPage: 1 });
    },
    handleCurrentChange(val) {
      this.$emit("change-page", { currentPage: val });
    },
  },

  destroyed() {},
};
</script>
<style lang="less" scope>
</style>
